import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { Logger, NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';

import { BaseBexApiStore } from './bex-api-store';

import analyticsWrapper from 'utility/analytics-wrapper';
import {
  FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoaded,
  FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoading,
  MerchandisingConfirmationPagePresentationLoaded,
  MerchandisingConfirmationPagePresentationLoading,
  Sdk
} from '__generated__/api/';

export class FlightsMerchandisingConfirmationStore extends BaseBexApiStore {
  @observable public loading: boolean;
  @observable public pagePresentation?: MerchandisingConfirmationPagePresentationLoaded.Fragment;
  @observable public pagePresentationLoading?: MerchandisingConfirmationPagePresentationLoading.Fragment;

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
  }

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, api: Sdk) {
    super(state, logger, api);
  }

  private addClientInfoHeader(headers, appName, region) {
    return {
      ...headers,
      'Client-Info': `${appName},latest,${region || 'external'}`
    };
  }

  public fetchLoading(
    detailsVariables: FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoading.Variables,
    options: HeadersInit,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoading.FlightsMerchandisingConfirmation> {
    return this.api
      .FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoading(detailsVariables, options)
      .then(response => {
        this.logger.logEvent(
          new SystemEvent(SystemEventLevel.INFO, 'MERCHANDISING_FETCH_LOADING_VARIABLES'),
          JSON.stringify(detailsVariables)
        );
        this.logger.logEvent(
          new SystemEvent(SystemEventLevel.INFO, 'MERCHANDISING_FETCH_LOADING_RESPONSE'),
          JSON.stringify(response)
        );
        const { flightsMerchandisingConfirmation } = response.data;

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsMerchandisingConfirmation
        };
      })
      .catch(error => {
        this.logger.logEvent(
          new SystemEvent(SystemEventLevel.CRITICAL, 'MERCHANDISING_CONFIRMATION_FETCH_LOADING'),
          error
        );

        return null;
      });
  }

  public fetchResults(
    detailsVariables: FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoaded.Variables,
    options: HeadersInit,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoaded.FlightsMerchandisingConfirmation> {
    return this.api
      .FlightsShoppingPwaMerchandisingConfirmationPagePresentationLoaded(detailsVariables, options)
      .then(response => {
        const { flightsMerchandisingConfirmation } = response?.data || {};

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsMerchandisingConfirmation
        };
      })
      .catch(error => {
        this.logger.logEvent(
          new SystemEvent(SystemEventLevel.CRITICAL, 'MERCHANDISING_CONFIRMATION_FETCH_LOADED'),
          error
        );

        return null;
      });
  }
}
